<div>
  @if (invoiceId && tenantId) {
    <app-checkout
      [invoiceId]="invoiceId"
      [tenantId]="tenantId"
      [isAPI]="true"
    ></app-checkout>
  }
</div>
